import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
  structuredData?: object[];
}
export function SEO({
  title,
  description,
  canonical,
  ogImage = 'https://cdn.magicpatterns.com/uploads/3FWPoSStYkTeUgaax2MNNb/Close_PartnerBadge_Top10_24.png',
  ogType = 'website',
  noindex = false,
  structuredData = []
}: SEOProps) {
  const siteUrl = 'https://close-crm-agentur.de';
  const fullTitle = `${title} | Close CRM Agentur`;
  const canonicalUrl = canonical || siteUrl;
  return <Helmet data-id="element-231">
      {/* Primary Meta Tags */}
      <html lang="de-DE" data-id="element-232" />
      <title data-id="element-233">{fullTitle}</title>
      <meta name="title" content={fullTitle} data-id="element-234" />
      <meta name="description" content={description} data-id="element-235" />
      <link rel="canonical" href={canonicalUrl} data-id="element-236" />

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" data-id="element-237" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-238" />
      <meta property="og:url" content={canonicalUrl} data-id="element-239" />
      <meta property="og:title" content={fullTitle} data-id="element-240" />
      <meta property="og:description" content={description} data-id="element-241" />
      <meta property="og:image" content={ogImage} data-id="element-242" />
      <meta property="og:locale" content="de_DE" data-id="element-243" />
      <meta property="og:site_name" content="Close CRM Agentur" data-id="element-244" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-245" />
      <meta property="twitter:url" content={canonicalUrl} data-id="element-246" />
      <meta property="twitter:title" content={fullTitle} data-id="element-247" />
      <meta property="twitter:description" content={description} data-id="element-248" />
      <meta property="twitter:image" content={ogImage} data-id="element-249" />

      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-250" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-251" />
      <meta name="language" content="German" data-id="element-252" />
      <meta name="author" content="Close CRM Agentur" data-id="element-253" />

      {/* Preconnect to external domains */}
      <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-254" />
      <link rel="preconnect" href="https://cdn.magicpatterns.com" data-id="element-255" />
      <link rel="preconnect" href="https://assets.calendly.com" data-id="element-256" />

      {/* Structured Data */}
      {structuredData.map((data, index) => <script key={index} type="application/ld+json" data-id="element-257">
          {JSON.stringify(data)}
        </script>)}
    </Helmet>;
}